import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ButtonToolbar } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import { CheckboxButton, ArchiveButton, EditButton } from "../../../common";
import { DataTable } from "../../../common/DataTable";
import BasicInsurerFields from "./BasicInsurerFields";

import { INSURERS } from "../../../../utils/data/models";
import * as dataActions from "../../../../utils/data/dataActions";

import { DIRECTOR } from "../../../../utils/Roles";
import userHasAccess from "../../../../utils/userHasAccess";

class InsurersDataTable extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.archiveInsurer = this.archiveInsurer.bind(this);
    this.createEmptyInsurerModel = this.createEmptyInsurerModel.bind(this);
    this.createInsurer = this.createInsurer.bind(this);
    this.setCellClassNames = this.setCellClassNames.bind(this);
    this.toggleArchivedInsurers = this.toggleArchivedInsurers.bind(this);
    this.updateInsurer = this.updateInsurer.bind(this);
    this.getData = this.getData.bind(this);
  }

  componentWillMount() {
    this.props.dataActions.clearDataList(INSURERS);
  }

  archiveInsurer(insurerId, isArchived) {
    this.props.dataActions
      .updateDataItem(INSURERS, { insurerId, isArchived: !isArchived })
      .then(() => {
        this.getData(
          this.props.offset,
          this.props.limit,
          this.props.q,
          this.props.sortBy,
          this.props.filters
        );
      });
  }

  createEmptyInsurerModel() {
    const localizations = {};
    [...this.props.languages]
      .sort((a, b) => a.languageCode.localeCompare(b.languageCode))
      .map((l) => {
        localizations[l.languageCode] = {
          name: "",
          languageCode: l.languageCode,
        };
      });

    return {
      localizations,
      address: "",
      city: "",
      provinceCode: "",
      postalCode: "",
      emergencyPhoneNumber: "",
      website: "",

      adminContactFullName: "",
      adminContactEmailAddress: "",
      adminContactPhoneNumber: "",
      adminContactLanguageCode: "",

      salesContactFullName: "",
      salesContactEmailAddress: "",
      salesContactPhoneNumber: "",
      salesContactLanguageCode: "",
    };
  }

  createInsurer(values) {
    const dataToUpdate = {
      ...values,
      adminContactLanguageCode:
        !values.adminContactLanguageCode ||
        values.adminContactLanguageCode.trim() == ""
          ? null
          : values.adminContactLanguageCode,
      salesContactLanguageCode:
        !values.salesContactLanguageCode ||
        values.salesContactLanguageCode.trim() == ""
          ? null
          : values.salesContactLanguageCode,
    };
    this.props.dataActions.createDataItem(INSURERS, dataToUpdate).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  setCellClassNames(insurer) {
    return classNames({
      archived: insurer.isArchived,
    });
  }

  toggleArchivedInsurers() {
    const isArchivedFiltered = this.props.filters.includes(
      INSURERS.archiveFilter
    );
    const filters = isArchivedFiltered
      ? this.props.filters.filter((filter) => filter != INSURERS.archiveFilter)
      : [...this.props.filters, INSURERS.archiveFilter];
    this.getData(
      this.props.offset,
      this.props.limit,
      this.props.q,
      this.props.sortBy,
      filters
    );
  }

  updateInsurer(values) {
    const dataToUpdate = {
      ...values,
      adminContactLanguageCode:
        !values.adminContactLanguageCode ||
        values.adminContactLanguageCode.trim() == ""
          ? null
          : values.adminContactLanguageCode,
      salesContactLanguageCode:
        !values.salesContactLanguageCode ||
        values.salesContactLanguageCode.trim() == ""
          ? null
          : values.salesContactLanguageCode,
    };
    this.props.dataActions.updateDataItem(INSURERS, dataToUpdate).then(() => {
      this.getData(
        this.props.offset,
        this.props.limit,
        this.props.q,
        this.props.sortBy,
        this.props.filters
      );
    });
  }

  getCols() {
    const { authLanguageCode } = this.props;
    return [
      {
        name: (
          <FormattedMessage id="admin.insurers.datatable.columns.insurer" />
        ),
        key: "localizations.name",
        display: (insurer) => (
          <span className={this.setCellClassNames(insurer)}>
            {insurer.localizations[authLanguageCode].name}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="admin.insurers.datatable.columns.contactFullName" />
        ),
        key: "adminContactFullName",
        display: (insurer) => (
          <span className={this.setCellClassNames(insurer)}>
            {insurer.adminContactFullName}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="admin.insurers.datatable.columns.phoneNumber" />
        ),
        key: "phoneNumber",
        display: (insurer) => (
          <span className={this.setCellClassNames(insurer)}>
            {insurer.adminContactPhoneNumber}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: (
          <FormattedMessage id="admin.insurers.datatable.columns.emailAddress" />
        ),
        key: "emailAddress",
        display: (insurer) => (
          <span className={this.setCellClassNames(insurer)}>
            {insurer.adminContactEmailAddress}
          </span>
        ),
        widthPct: 20,
      },
      {
        name: <FormattedMessage id="datatable.actions" />,
        display: (insurer) => this.generateActionButtons(insurer),
        widthPct: 20,
      },
    ];
  }
  renderFormatedMessage(icon) {
    return <span className="icon warning">{icon}</span>;
  }
  generateActionButtons(insurer) {
    const { authLanguageCode } = this.props;
    return (
      <ButtonToolbar key={insurer.insurerId}>
        <EditButton
          modalClassName="extra-large-modal"
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          title={
            <FormattedMessage id="admin.insurers.datatable.actions.edit" />
          }
          form={BasicInsurerFields}
          label={<FormattedMessage id="common.edit" />}
          data={
            this.props.active.insurerId == insurer.insurerId
              ? this.props.active
              : null
          }
          getData={this.props.dataActions.getDataItem.bind(
            this,
            INSURERS,
            insurer.insurerId,
            null,
            {
              "Accept-Language": this.props.languages.map(
                (l) => l.languageCode
              ),
            }
          )}
          editFunction={this.updateInsurer}
        />
        {!insurer.isArchived && (
        <ArchiveButton
          isArchived={insurer.isArchived}
          disabled={!userHasAccess(DIRECTOR)}
          archivedName={insurer.localizations[authLanguageCode].name}
          warningMessage={
            insurer.isArchived ? (
              ""
            ) : (
              <FormattedMessage id="archiveButton.warningMessage.insurers" />
            )
          }
          archiveFunction={this.archiveInsurer.bind(
            null,
            insurer.insurerId,
            insurer.isArchived
          )}
          label={
            insurer.isArchived ? (
              <FormattedMessage id="common.unarchive" />
            ) : (
              <FormattedMessage id="common.archive" />
            )
          }
        />          
      )}
      </ButtonToolbar>
    );
  }

  generateAddButton() {
    return (
      <div>
        <CheckboxButton
          className="include-archived"
          id="archived"
          label={
            <FormattedMessage id="admin.insurers.datatable.actions.includeArchivedInsurers" />
          }
          checked={!this.props.filters.includes(INSURERS.archiveFilter)}
          onClick={this.toggleArchivedInsurers}
        />
        <EditButton
          confirmationTitle={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.title">
              {this.renderFormatedMessage}
            </FormattedMessage>
          }
          confirmationMessage={
            <FormattedMessage id="admin.blocs.datatable.actions.showConfirm.message" />
          }
          closeButtonKey="common.cancel"
          requiresCloseConfirmation={true}
          confirmOnClose={true}
          modalClassName="extra-large-modal"
          title={<FormattedMessage id="admin.insurers.datatable.actions.add" />}
          label={<FormattedMessage id="common.add" />}
          add={true}
          form={BasicInsurerFields}
          data={this.createEmptyInsurerModel()}
          editFunction={this.createInsurer}
        />
      </div>
    );
  }

  getData(offset, limit, q, sortBy, filters) {
    return this.props.dataActions.getDataList(
      INSURERS,
      offset,
      limit,
      q,
      sortBy,
      filters
    );
  }

  render() {
    return (
      <DataTable
        ref="dataTable"
        title={<FormattedMessage id="admin.insurers.title" />}
        getData={this.getData}
        cols={this.getCols()}
        q={this.props.q}
        filters={this.props.filters}
        offset={this.props.offset}
        data={this.props.items}
        rowsPerPage={this.props.limit}
        totalRows={this.props.total}
        sortBy={this.props.sortBy}
        addButton={this.generateAddButton()}
      />
    );
  }
}

InsurersDataTable.propTypes = {
  active: PropTypes.object,
  authLanguageCode: PropTypes.string,
  dataActions: PropTypes.object,
  filters: PropTypes.array,
  insurersActions: PropTypes.object,
  items: PropTypes.array,
  q: PropTypes.string,
  languages: PropTypes.array.isRequired,
  limit: PropTypes.number,
  offset: PropTypes.number,
  sortBy: PropTypes.array,
  total: PropTypes.number,
  userLanguage: PropTypes.string,
  insurers: PropTypes.array,
};

InsurersDataTable.defaultProps = { limit: 10 };

function mapStateToProps(state) {
  const data = state.data.insurers || {};
  const pagination = data.pagination || {};
  return {
    active: data.active || {},
    authLanguageCode: state.auth.user.languageCode,
    limit: pagination.limit || 100,
    offset: pagination.offset || 0,
    sortBy: data.sortBy || ["localizations.name:asc"],
    q: data.q,
    filters: data.filters || [INSURERS.archiveFilter, "isVisible==true"],
    total: pagination.totalCount || 0,
    items: data.items || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InsurersDataTable);



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/insurers/InsurersDataTable.js